var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgLeftOutline = function SvgLeftOutline(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(50.000000, 50.000000) scale(-1, 1) rotate(-90.000000) translate(-50.000000, -50.000000) translate(0.000000, 21.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.0063637,40.4576169 L12.1802215,2.12799068 C9.38017053,-0.709330228 4.90008909,-0.709330228 2.10003818,2.12799068 C-0.700012728,4.9653116 -0.700012728,9.50502506 2.10003818,12.342346 L43.9480718,54.7473966 C44.2026218,55.1600982 44.5080819,55.5212115 44.8644521,55.8823253 C46.2899325,57.3267794 48.1226932,58.0490065 50.0063637,57.9974187 C51.8391244,57.9974187 53.7227947,57.3267794 55.1482753,55.8823253 C55.5046458,55.5212115 55.8101058,55.1600982 56.0646558,54.7473966 L97.9126895,12.342346 C99.28726,10.9494794 100,9.09232384 100,7.23516832 C100,5.37801285 99.28726,3.52085732 97.9126895,2.12799068 C95.1126384,-0.709330228 90.6325568,-0.709330228 87.8325058,2.12799068 L50.0063637,40.4576169 Z"
  }))))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgLeftOutline);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "left-outline.0518728415c440e7e3793e5f7faa94d3.svg";